import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isOnboarding } from "./config";
const PrivateRoute = () => {
  if (!localStorage.getItem("accessToken")) {
    return <Outlet />;
  } else {
    if (isOnboarding() == false) {
      return <Navigate to="/register-distribution-details" />;
    } else return <Navigate to="/current-orders" />;
  }
};

export default PrivateRoute;
